export default __webpack_public_path__ + "/dist/images/6724585.74214caa7d44d185ac00f0fd447eaeb6.png";